import React, { useEffect, useState } from 'react';
import {
  StCountTrailCircle,
  StCountTrailCircleLabel,
  StCountTrailContainer,
  StCountTrailWrapper,
  StRichTextGridItem,
  ViewTrialsButton,
} from './CountTrial.styles';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { useRouter } from 'next/router';
import Stack from '@mui/material/Stack';
import { useCountTrial } from 'lib/hooks/coveo/useCountTrial';
import featchCountTrailHeadlessEnginee from 'lib/utils/coveo/featchCountTrailHeadlessEnginee';
import { buildQuerySummary } from '@coveo/headless';
import { useSelector, useDispatch } from 'react-redux';
import { setShowAnyLocation } from 'src/features/coveoSlice';
import { RootState } from '../../../store/store';

export const mergeTag = (text: string, dataObject: Record<string, any>): string => {
  if (text === undefined) return '';
  const regex = /\[(.*?)\]/g;

  const modifiedText = text.replace(regex, (match, fieldName) => {
    if (dataObject?.hasOwnProperty(fieldName)) {
      return dataObject[fieldName];
    } else {
      return match;
    }
  });

  return modifiedText;
};

const CountTrial: React.FC<any> = (props) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const [trialsList, setTrialsList] = useState<any>([]);
  const [totalTrialCount, setTrialCount] = useState<any>([]);

  const router = useRouter();
  const countLabel = props?.fields?.countLabel;
  const countText = props?.fields?.countText;
  const viewTrialButton = props?.fields?.viewTrialButton;
  const relatedCommunityConditions = props.fields?.relatedCommunityConditions;
  const queryParam = relatedCommunityConditions
    ?.map((condition: any) => condition.key)
    .join(' and ');
  const { data } = useCountTrial(featchCountTrailHeadlessEnginee, queryParam);
  const controller = buildQuerySummary(featchCountTrailHeadlessEnginee);
  const [state, setState] = useState(controller.state);
  const dispatch = useDispatch();
  const showLocationValue = useSelector((state: RootState) => state.coveoResult.showAnyLocation);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setTrialsList(data?.results);
      controller.subscribe(() => setState(controller.state));
      setTrialCount(state.total);
    }
  }, [data]);

  const handleViewTrials = () => {
    if (relatedCommunityConditions?.length === 0) return;
    const URL = viewTrialButton?.value?.href;

    if (showLocationValue === false) {
      dispatch(setShowAnyLocation());
    }
    router.push(`${URL}#q=${queryParam || ''}&f-trialenrollingstatus=Enrolling`);
  };

  return (
    <StCountTrailWrapper id="count-trial">
      <StCountTrailContainer>
        <Grid container>
          <Stack direction={isDesktop ? 'row' : 'column'} spacing={2}>
            <Grid item xs={isDesktop ? 8 : 12}>
              <StRichTextGridItem>
                <RichText field={props?.fields?.trialContent} data-testid="count-trial-content" />
              </StRichTextGridItem>
            </Grid>
            <Grid
              item
              xs={isDesktop ? 4 : 12}
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: isDesktop ? 'none' : '12rem',
              }}
            >
              <StCountTrailCircle>
                <Grid className="content">
                  <Typography
                    variant="h1"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      color: '#C6FCFF',
                      fontSize: '60px',
                    }}
                  >
                    {mergeTag(countText?.value, { count: trialsList ? totalTrialCount : 0 })}
                  </Typography>
                  <StCountTrailCircleLabel>
                    {countLabel?.value || 'RECRUITING TRIALS'}
                  </StCountTrailCircleLabel>
                </Grid>
                <Grid className="view-trail" sx={{ paddingTop: '2rem' }}>
                  <ViewTrialsButton
                    className={'view-trail-btn btn'}
                    type="submit"
                    variant="outlined"
                    tabIndex={0}
                    onClick={handleViewTrials}
                  >
                    {viewTrialButton?.value?.text}
                  </ViewTrialsButton>
                </Grid>
              </StCountTrailCircle>
            </Grid>
          </Stack>
        </Grid>
      </StCountTrailContainer>
    </StCountTrailWrapper>
  );
};

export default CountTrial;
